import { ICheckoutTheme } from '../../../../../common/theme/ICheckoutTheme';
import { makeStyles } from '@material-ui/core/styles';

export type DealerSummaryClasses = 'dealerSummary' | 'dealerName' | 'dealerAddress' | 'dealerItem' | 'disclaimerText';

const dealerSummaryStyles = makeStyles<ICheckoutTheme, DealerSummaryClasses>(
  ({ palette, typography }) => ({
    dealerSummary: {},
    dealerName: {
      textTransform: 'uppercase',
      color: palette.common.black,
    },
    dealerAddress: {},
    dealerItem: {},
    disclaimerText: {
      fontSize: typography.fontSM,
      fontWeight: 400,
      lineHeight: '140%',
      paddingBottom: '4px',
    },
  }),
  { name: 'Checkout4_DealerSummary' },
);

export default dealerSummaryStyles;
